// interfaccia generica
export interface IUser {
  id: number;
  userName: string;
  firstName: string;
  lastName: string;
  email: string;
  logoutUrl:string;
  languageId: number;
}

export interface ISimpleUser {
  id: number;
  firstName: string;
  lastName: string;
  role: string;
}

export interface IAttendingUser {
  id: number;
  firstName: string;
  lastName: string;
  userName: string;
  lastActivity: Date;
}

// interfaccia per login e registrazione
export interface IUserFormValues {
  email: string;
  userName: string;
  password: string;
  companyId: number;
  approverEmail: string;
  token?: string;
  languageId? : number
}

export interface IResetPwdFormValues {
  email: string;
  companyId: number;
  IsPlayer?: boolean;
}

export interface IOtpFormValues {
  email: string;
  otp: number;
  password?: string;
  companyId: number;
}

// interfaccia per conferma recupero password
export interface IUserConfirmResetPwdValues {
  id: number;
  token: string;
  password: string;
}

// interfaccia profilo utente
export interface IUserProfile extends Partial<IUser> {
  phoneNumber?: string;
  roles: IUserInRole[];
}

export interface IUserInRole {
  roleName: string;
  isInRole: boolean;
}

// interfaccia e classe per form modifica utenti
export interface IUserProfileFormValues extends Partial<IUser> {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  role?: string;
  languageId?: number;
}

export class UserProfileFormValues implements IUserProfileFormValues {
  id?: number = undefined;
  userName: string = "";
  firstName?: string = "";
  lastName?: string = "";
  email?: string = "";
  phoneNumber?: string = "";
  role?: string = "";
  languageId?: number = 0;

  constructor(init?: IUserProfileFormValues) {
    Object.assign(this, init);
    if (init && init.languageId) this.languageId = init.languageId
    
  }
}

// interfaccia per login e registrazione
export interface IChangePwdFormValues {
  oldPassword: string;
  newPassword: string;
}

export class ChangePwdFormValues implements IChangePwdFormValues {
  oldPassword: string = "";
  newPassword: string = "";
  confirmNewPwd: string = "";

  constructor(init?: IChangePwdFormValues) {
    Object.assign(this, init);
  }
}

export const getDisplayName = (user: IUser) => {
  return user.lastName && user!.firstName
    ? `${user.firstName} ${user.lastName}`
    : user.email;
};
export interface IRegistrationDto {
  email: string;
  userName: string;
  password: string;
  companyId: number;
  approverEmail: string;
  languageId? : number;
}

export class RegistrationFormValues implements IRegistrationDto {
  email: string="";
  userName: string="";
  firstName: string="";
  lastName: string="";
  password: string="";
  companyId: number=0;
  approverEmail: string="";
  phoneNumber: string ="";
  languageId?: number | undefined;
  confermRegistration: boolean= false;
  constructor(init?: IRegistrationDto) {
    Object.assign(this, init);
  }

  
}

// AUTHENTICATOR APP

export interface IAuthenticatorFormValues {
  email: string;
  password?: string;
  companyId: number;
}



export interface LoginAuthenticatorApp{
token: string;
isVisibleQrCode: boolean;
  
}


export interface AuthenticatorQRcodeInfo{
 url: string;
 secret: string;
}


